const CDN_DOMAIN = 'https://assets.viome.com/assets';
const S3_CDN_DOMAIN = 'https://static.viome.com/media/app';

// Company Logos
export const LOGO_WHITE = `${CDN_DOMAIN}/image/logo-white.svg`;

// Universal Search
export const MY_FOODS_BADGE = `${CDN_DOMAIN}/image/pages/universal-search/my-foods-badge.png`;
export const MY_INGREDIENTS_BADGE = `${CDN_DOMAIN}/image/pages/universal-search/my-ingredients-badge.png`;

// Nutrition
export const GEL = `${CDN_DOMAIN}/image/pages/nutrition/gel.png`;
export const BIOTICS = `${CDN_DOMAIN}/image/pages/nutrition/biotics.png`;
export const LOZENGES = `${CDN_DOMAIN}/image/pages/nutrition/lozenges.png`;
export const SUPPLEMENTS = `${CDN_DOMAIN}/image/pages/nutrition/supplements.png`;

// Formula Images
export const SUPPLEMENT_IMAGE = `${S3_CDN_DOMAIN}/banners/static/supplement.png`;
export const SUPPLEMENT_BACKGROUND = `${S3_CDN_DOMAIN}/banners/static/supplement_background.png`;
export const ORAL_LOZENGES = `${S3_CDN_DOMAIN}/banners/static/oral_lozenges.png`;
export const ORAL_LOZENGES_BACKGROUND = `${S3_CDN_DOMAIN}/banners/static/oral_lozenges_background.png`;
export const GUT_PASTE = `${S3_CDN_DOMAIN}/banners/static/gut_paste.png`;
export const GUT_PASTE_BACKGROUND = `${S3_CDN_DOMAIN}/banners/static/gut_paste_background.png`;
export const GUT_FORMULA = `${S3_CDN_DOMAIN}/banners/static/gut_formula.png`;
export const GUT_FORMULA_BACKGROUND = `${S3_CDN_DOMAIN}/banners/static/gut_formula_background.png`;

//Home Images
export const HOME_POST_RNR_BACKGROUND = 'https://res.cloudinary.com/dttltpafi/image/upload/v1741260102/Hero_Background_4_fjwbrm.jpg';
export const HOME_PRE_RNR_BACKGROUND = `${S3_CDN_DOMAIN}/banners/static/home_pre_rnr_background.png`;
export const COMMUNITY_CARD_BACKGROUND = `${S3_CDN_DOMAIN}/v2/png/home/home_rnr_community_card_background.png`;
export const HEALTH_CONNECTION_SECTION_BACKGROUND = `${S3_CDN_DOMAIN}/v2/png/home/health_connection_section_background.png`;
export const HEALTH_INSIGHT_CARD_BACKGROUND = 'https://static.viome.com/media/app/v2/png/web/heallth_hero_section_background.png';
export const HEALTH_INSIGHT_SECTION_BACKGROUND= `${S3_CDN_DOMAIN}/v2/png/home/home_rnr_health_insights_background.png`;
export const MY_NUTRITION_CARD_BACKGROUND = `${S3_CDN_DOMAIN}/v2/png/home/my_nutrition_card_background.png`;
export const REFERAL_CARD_BACKGROUND = `${S3_CDN_DOMAIN}/v2/png/home/referal_card_background.png`;
export const MY_FORMULA_SECTION_BACKGROUND = `${S3_CDN_DOMAIN}/v2/jpg/home/my_formula_section_background.jpeg`;


